import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Pagination {
  page: number;
  empty: boolean;
  totalPages: number;
  pageSize?: number;
  hidePageSize?: boolean;
}

export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_SIZES = [10, 20, 30, 50, 100];
const MAX_PAGES = 6;

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  public pageSizes: Array<number> = DEFAULT_PAGE_SIZES;
  public selectedPageSize: number = DEFAULT_PAGE_SIZE;
  public loadingLines: Array<number> = [];
  public pages: number[] = [];
  public canGoBack = false;
  public canGoForward = false;
  @Input() totalPages: number;
  @Input() pagination: Pagination;
  @Output() onSelectPageSize: EventEmitter<any> = new EventEmitter();
  @Output() onChangeCurrentPage: EventEmitter<number> = new EventEmitter();

  ngOnChanges() {
    const pages: any[] = [];
    if (this.pagination.totalPages) {
      const totalPages = this.pagination.totalPages;
      const currentPage = this.pagination.page;
      // Default page limits
      let startPage = 0;
      let endPage = totalPages;
      const isMaxSized = MAX_PAGES < totalPages;

      // recompute if maxSize
      if (isMaxSized) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(MAX_PAGES / 2), 0);
        endPage = startPage + MAX_PAGES + 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - MAX_PAGES + 1;
        }
      }
      // Add page number links
      for (let num = startPage; num < endPage; num++) {
        pages.push(num);
      }
      this.canGoBack = totalPages > 0 && !endPage;
      this.canGoForward = totalPages > 0 && !startPage;
    }
    this.pages = pages || [];
  }

  public selectPageSize(size: number): void {
    this.selectedPageSize = size;
    this.onSelectPageSize.emit(this.selectedPageSize);
  }

  public goToPage(p): void {
    if (this.pagination.page !== p && p !== '...') {
      this.pagination.page = p;
      this.onChangeCurrentPage.emit(p);
    }
  }

  public nextPage(): void {
    this.pagination.page += 1;
    this.onChangeCurrentPage.emit(this.pagination.page);
  }

  public prevPage(): void {
    this.pagination.page -= 1;
    this.onChangeCurrentPage.emit(this.pagination.page);
  }

  public prevDisabled(): boolean {
    return this.pagination.page === 0 || this.pagination.totalPages === 0;
  }

  public nextDisabled(): boolean {
    return this.pagination.page === this.pages[this.pages.length - 1] || this.pagination.totalPages === 0;
  }

  public goFirstPage(): void {
    this.onChangeCurrentPage.emit(0);
  }

  public goLastPage(): void {
    this.onChangeCurrentPage.emit(this.pagination.totalPages - 1);
  }
}
